import React, { FC } from 'react';
import { Avatar as AntdAvatar, Skeleton } from 'antd';
import styled from 'styled-components';
import { AvatarProps } from 'antd/lib/avatar';

import { PersonIcon } from '~/img';
import { FileType } from '~/api/file';
import useLoadImage from '~/hooks/useLoadImage';

interface Props extends AvatarProps {
  loading?: boolean;
  size?: number | 'large' | 'small' | 'default';
  file?: FileType;
}

const Avatar: FC<Props> = (props) => {
  const { loading, size, file, src, className, ...rest } = props;
  const imageLoad = useLoadImage(file);
  const resultLoading = imageLoad.loading || loading;
  const resultSrc = src || imageLoad.dataURL;

  return (
    <div className={className}>
      {resultLoading ? (
        <Skeleton.Avatar size={size} active />
      ) : (
        <AntdAvatar size={size} icon={<PersonIcon />} src={resultSrc} {...rest} />
      )}
    </div>
  );
};

export default styled(Avatar)`
  .ant-avatar-image {
    box-shadow: 0px 0px 2px 0px rgb(34 60 80 / 20%);
  }
  .ant-skeleton-element {
    display: flex;
  }
`;
